import { ACTION_TYPE_LABEL } from "../../app/labels.js";
import { Link, navigate } from "../../app/router.js";
import { useTenant } from "../../app/tenant.js";
import { Badge, EmptyState, Icon, PageHead } from "../../ui/index.js";
import { ActionEditor } from "./ActionEditor.js";

function BackToActions() {
  return (
    <Link to="/actions" className="back-link">
      <Icon name="arrowLeft" size={14} /> Actions
    </Link>
  );
}

export function EditActionScreen({ id }: { id: string }) {
  const { actions } = useTenant();
  const action = actions.find((candidate) => candidate.id === id);
  if (action === undefined) {
    return (
      <>
        <BackToActions />
        <EmptyState title="That action does not exist." />
      </>
    );
  }
  return (
    <>
      <BackToActions />
      <PageHead title={action.name} aside={<Badge tone="outline">{ACTION_TYPE_LABEL[action.type]}</Badge>} />
      <ActionEditor action={action} onDone={() => { navigate("/actions"); }} />
    </>
  );
}
